import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  AfterViewInit,
  Input,
  ContentChild,
  TemplateRef,
} from "@angular/core";
import { confetti, ConfettiConfig } from "dom-confetti";
import {
  ApplicationBaseData,
  ApplicationOfferBundleData,
} from "../../../application/application.model";
import { DisplayAllOffersData } from "../../models/display-all-offers-data.model";
import { isLargeLoanProgramOffer } from "../../models/large-loan-program.model";
import { getOfferTermLabel } from "../../pipes/offer-term-label-pipe";
import { OfferSummaryFacade } from "./offer-summary.facade";

@Component({
    selector: "ifc-offer-summary",
    templateUrl: "./offer-summary.component.html",
    styleUrls: ["./offer-summary.component.scss"],
    providers: [OfferSummaryFacade],
    standalone: false
})
export class OfferSummaryComponent implements OnInit, AfterViewInit {
  @ViewChild("confettiCanvas", { static: true }) confettiCanvas: ElementRef;

  @Input()
  application: ApplicationBaseData;

  @Input()
  offerBundles: ApplicationOfferBundleData[];

  @ContentChild("shareOffer", { read: TemplateRef })
  shareOfferRef: TemplateRef<unknown>;

  @ContentChild("contactFooter", { read: TemplateRef })
  contactFooterRef: TemplateRef<unknown>;

  bestOfferBundles: ApplicationOfferBundleData[];
  maxOfferAmount: number;
  maxOfferRepaymentLabel: string;
  largeLoanProgramOffered: boolean;

  constructor(private facade: OfferSummaryFacade) {}

  ngOnInit() {
    this.bestOfferBundles = this.facade.getBestOfferBundles(this.offerBundles);
    // Every offer, not just the cards: a card shows one offer per product.
    this.maxOfferAmount = this.facade.getMaxOfferAmount(this.offerBundles);
    this.maxOfferRepaymentLabel = getOfferTermLabel(this.facade.getMaxRepayment(this.offerBundles));
    this.largeLoanProgramOffered = this.bestOfferBundles.some(isLargeLoanProgramOffer);
  }

  ngAfterViewInit(): void {
    this.showConfetti();
  }

  private showConfetti() {
    window.setTimeout(() => {
      confetti(this.confettiCanvas.nativeElement, <ConfettiConfig>{
        angle: 90,
        spread: 360,
        startVelocity: 50,
        elementCount: 100,
      });
    }, 1000);
  }

  onDisplayAllOffers(data: DisplayAllOffersData): void {
    this.facade.displayAllOffers(data);
  }

  onLinkBank(entityId: number): void {
    this.facade.linkBank(entityId);
  }
}
